export default "__VITE_ASSET__Hdv8nimx__"